'use strict';

angular.module('app').directive('showMap', function ($timeout, $location) {

    var link = function (scope, element, attr) {
        var map = $('#search-map'),
            firstOpen = true,
            mapContainer = $('.search-page-map-wrapper'),
            filters = $('.filters'),
            searchWrapper = $('.search-wrapper'),
            resultList = $('.result-list'),
            coverImage = $('.cover-image'),
            mainFooter = $('#main-footer'),
            siteHeader = $('.site-header'),
            mapHeader = $('.map-header'),
            mobileHeader = $('.mobile-header'),
            headerHeight = $('.padi-header').innerHeight() + $('.site-header').innerHeight(),
            filterWidth = filters.innerWidth();

        $(element).click(triggerMap);
        $(".btn-go-to-list").click(triggerMap);
        $("#js-action-map").click(triggerMap);
        $(window).on('resize', updateMap);

        if ($location.search() && $location.search().view === 'map') {
            triggerMap(true);
        }

        function triggerMap (noUpdate) {
            mapContainer.toggleClass('visible');
            map.toggleClass('hidden');
            resultList.toggleClass('hidden');
            searchWrapper.toggleClass('full-width');
            filters.toggleClass('map-full-width');
            coverImage.toggleClass('hidden');
            mainFooter.toggleClass('hidden');
            siteHeader.toggleClass('hidden');
            mapHeader.toggleClass('hidden');
            mobileHeader.toggleClass('map-open');

            // hide support buttons
            if (window.innerWidth <= 1024){
                $("#chat-buttons").toggleClass('hidden');
            }
            console.log(filters.hasClass('map-full-width'))

            if (filters.hasClass('map-full-width')) {
                $location.search('view', 'map');

                if (window.innerWidth >= 768) {
                    filters.css({
                        'width': filterWidth + 40,
                        'height': window.innerHeight - headerHeight
                    });
                    // scroll to filters
                    filters.animate({
                        scrollTop: $("#js-filter-list").position().top
                    }, 800);
                }else {
                    $('.filter-expand').click();
                }
            } else {
                $timeout(function() {
                    $location.search('view',null);
                })
                filters.css({
                    'width': '',
                    'height': ''
                });
                filters.scrollTop(0);
            }
            
            if (!noUpdate) {
                scope.$apply();
            }

            setTimeout(updateMap, 150)
        }

        function updateMap() {
            var width = window.innerWidth >= 768 ? window.innerWidth - filters.outerWidth() - 20 : '100%';
            map.css({
                width: width
            });
            mapContainer.css({
                width: width
            });
            
            if (scope.mapContainer && $location.search().view === 'map') {
                scope.mapContainer.invalidateSize();
                
                // if (firstOpen) {
                    scope.mapContainer.fitBounds(scope.locationCoordinates);
                    // firstOpen = false;
                // }
                
                scope.$emit('leafletDirectiveMap.search-map.zoomend')
            }
        }

        scope.$on('$routeChangeStart',function() {
            map.addClass('hidden');
            resultList.removeClass('hidden');
            searchWrapper.removeClass('full-width');
            filters.removeClass('map-full-width');
            coverImage.removeClass('hidden');
            mainFooter.removeClass('hidden');
            if (window.innerWidth <= 1024) {
                $("#chat-buttons").toggleClass('hidden');
            }
        });
    }

    return {
        restrict: 'A',
        replace: false,
        scope: {
            currentView: '=',
            callback: '&',
            mapContainer: '=',
            locationCoordinates: '='
        },
        link: link
    };
});
